import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ShopTheLookModal } from '@components/ShopTheLookModal/ShopTheLookModal'
import { ProductPage } from '@velasca/ui/product-page'

interface ConditionalShopTheLookProps {
  condition: boolean
  shopTheLookIDs: string[] | undefined
  children: React.ReactNode
  editorialImage?: string | null
}

export const ConditionalShopTheLook = ({
  condition,
  shopTheLookIDs,
  children,
  editorialImage,
}: ConditionalShopTheLookProps) => {
  const { t } = useTranslation('product')
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  if (condition) {
    return (
      <ShopTheLookModal
        drawerTitle={t('productPageShopTheLookDrawerTitle')}
        title={t('productPageShopTheLookTitle')}
        subtitle={t('productPageShopTheLookSubtitle')}
        productIDs={shopTheLookIDs}
        editorialImage={editorialImage}
        isOpen={isPopupOpen}
        onClose={setIsPopupOpen}
      >
        <ProductPage.StyledShopTheLookButton
          onClick={() => {
            setIsPopupOpen(true)
          }}
        />
        {children}
      </ShopTheLookModal>
    )
  }

  return children
}
